import ChevronRightWhiteIcon from "@/User/Assets/Svgs/ChevronRightWhiteIcon.svg";
import PrimaryButton from "@/User/Components/Buttons/PrimaryButton";
import { RouteName } from "@/User/Constants/routes";
import React from 'react';
import route from 'ziggy-js';

const EntryButton = ({
    labelText = null,
    onClick = null,
    className = 'px-10 py-4',
    labelClassName = 'leading-none',
    badgeClassName = 'text-sm leading-tight',
    haveIcon = true,
    classIconName = '',
}) => (
    <PrimaryButton
        as={onClick ? 'button' : 'link'}
        href={!onClick && route(RouteName.RegistrationPage)}
        className={`inline-flex w-full gap-2 justify-center items-center ${className}`}
        textClass="text-base text-white"
        isRounded={true} roundedClass="rounded-lg"
        isShadow={true} shadowClass="shadow-prussian-blue shadow-entry"
        onClick={onClick}
    >
        <span className={labelClassName}>{labelText ?? '会員登録する'}</span>
        <span className={`bg-lemon rounded px-2 py-1 text-primary ${badgeClassName}`}>無料</span>
        {haveIcon && (
            <span>
                <img src={ChevronRightWhiteIcon} alt="会員登録する" className={classIconName} />
            </span>
        )}
    </PrimaryButton>
);

export default EntryButton;
